
import React from "react";
import ReactDOM from "react-dom";

import { MoralisProvider } from "react-moralis";
import { BrowserRouter } from "react-router-dom";

import "./assets/fonts/The_Impostor.ttf";
import "./styles/app.css";

import App from "./App";
import dotenv from "dotenv";
dotenv.config();
const { REACT_APP_MORALIS_APP_ID, REACT_APP_SERVER_URL, REACT_APP_CHAIN, REACT_APP_ALCHEMY_API_KEY } = process.env;
console.log('[index.tsx] Moralis Server URL:', REACT_APP_SERVER_URL);
console.log('[index.tsx] REACT_APP_ALCHEMY_API_KEY:', REACT_APP_ALCHEMY_API_KEY);
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <MoralisProvider appId={REACT_APP_MORALIS_APP_ID} serverUrl={REACT_APP_SERVER_URL} initializeOnMount={true}>
        <App />
      </MoralisProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
